define('lib/Podio.Favicon',['require','jquery','lib/view_helpers/base'],function(require) {

  var $ = require('jquery');
  var viewHelpers = require('lib/view_helpers/base');

  var notifUrl = viewHelpers.image_url('favicon-notify.svg');
  var originalFavIconUrl;

  function setFaviconTag(url) {

    // Remove existing
    $('link[rel~=icon]').remove();

    // Inject new
    var elmLink = $('<link />', {
      rel: 'shortcut icon',
      href: url
    });

    elmLink.appendTo($('head'));
  }

  function setCount(num) {

    num = num || 0;

    if( !originalFavIconUrl ) {
      originalFavIconUrl = $('link[rel~=icon]').attr('href') || '/favicon.svg';
    }

    var newFavIconUrl = num > 0 ? notifUrl : originalFavIconUrl;

    setFaviconTag(newFavIconUrl);
  }

  return {
    setCount: setCount
  };

});

